import { StrictMode, type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import '@fontsource-variable/manrope';
import './styles/tokens.css';
import './styles/app.css';
import './styles/platform.css';
import './styles/saas003.css';
import './styles/saas007.css';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { ToastProvider } from './components/Toast';
import { Login } from './pages/Login';
import { NotFound } from './pages/NotFound';
import { PLATFORM_BASE, PlatformRoot } from './platform/PlatformAdmin';
import { PlatformActivation } from './platform/PlatformActivation';

function RequireAdminSession({children}:{children:ReactNode}) {
  const {status}=useAuth(); const location=useLocation();
  if(status==='loading') return <div className="sr-only" role="status">Carregando sessão…</div>;
  if(status==='anonymous') return <Navigate to="/login" replace state={{from:location.pathname}}/>;
  return <>{children}</>;
}
function Root(){const {status}=useAuth();if(status==='loading')return <div className="sr-only" role="status">Carregando sessão…</div>;return <Navigate to={status==='anonymous'?'/login':PLATFORM_BASE} replace/>;}
function Title(){document.title='Administração da plataforma · InteliMove';return null;}

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><AuthProvider><ToastProvider><Title/><Routes>
  <Route path="/" element={<Root/>}/><Route path="/login" element={<Login administrative/>}/><Route path="/ativar" element={<PlatformActivation/>}/>
  <Route path={`${PLATFORM_BASE}/*`} element={<RequireAdminSession><PlatformRoot/></RequireAdminSession>}/><Route path="*" element={<NotFound/>}/>
</Routes></ToastProvider></AuthProvider></BrowserRouter></StrictMode>);
